const CurrencyID = Object.freeze({
  TWD: 0,
  HKD: 1,
  JPY: 2,
  MYR: 3,
  THB: 4
})

export {
  CurrencyID
}
